var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-landing-page-tab-container mb-3 mt-3" }, [
    _c("div", { staticClass: "mobile-navigation mb-2" }, [
      _c("div", { staticClass: "wf-mobile-title" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
      ]),
      _vm._v(" "),
      _c(
        "select",
        { staticClass: "custom-select", on: { change: _vm.changeTab } },
        _vm._l(_vm.documents, function(document, index) {
          return _c(
            "option",
            {
              key: document.id,
              domProps: { selected: index === 0, value: document.id }
            },
            [
              _vm._v(
                "\n                " + _vm._s(document.title) + "\n            "
              )
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wf-landing-page-tab-wrapper pr-2" },
      [
        _c("div", { staticClass: "wf-landing-page-tab border-bottom" }, [
          _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
        ]),
        _vm._v(" "),
        _vm._l(_vm.documents, function(document, index) {
          return _c(
            "div",
            {
              key: document.id,
              class: [
                index == 0
                  ? "wf-landing-page-tab wf-landing-page-tab-active"
                  : "wf-landing-page-tab",
                index != _vm.documents.length - 1 ? "" : "border-bottom"
              ],
              attrs: { id: document.id },
              on: { click: _vm.changeTab }
            },
            [_vm._v("\n            " + _vm._s(document.title) + "\n        ")]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "wf-landing-page-tab-content" }, [
      _c("section", { staticClass: "wf-landing-page-tab-content-section" }, [
        _vm.documents && _vm.documents.length > 0
          ? _c("div", { staticClass: "h4" }, [_vm._v(_vm._s(_vm.title))])
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "widget-content",
          domProps: { innerHTML: _vm._s(this.pageContent) }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }